/* eslint-disable no-unused-vars */
import React, { useEffect, useContext } from 'react';

import LeftSidebar from '../LeftSidebar/LeftSidebar';
import AppContext from '../../context/AppContext';

// Resume Templates
import Onyx from '../../templates/onyx';
import Pikachu from '../../templates/pikachu';
import Gengar from '../../templates/gengar';
import Castform from '../../templates/castform';
import Celebi from '../../templates/celebi';

const App = () => {
  const context = useContext(AppContext);
  const { state, dispatch } = context;
  const { theme } = state;

  useEffect(() => {
    const storedState = JSON.parse(localStorage.getItem('state'));
    dispatch({ type: 'import_data', payload: storedState });
  }, [dispatch]);

  const renderTemplate = () => {
    switch (theme.layout) {
      case 'Onyx':
        return <Onyx />;
      case 'Pikachu':
        return <Pikachu />;
      case 'Gengar':
        return <Gengar />;
      case 'Castform':
        return <Castform />;
      case 'Celebi':
        return <Celebi />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen lg:h-screen lg:overflow-hidden grid grid-cols-1 lg:grid-cols-5 items-center lg:items-stretch lg:p-0">
      <LeftSidebar />

      <div id="content-wrapper" className="z-0 h-auto lg:h-screen col-span-1 lg:col-span-3 flex justify-center items-start lg:items-center overflow-scroll py-8 lg:py-0 bg-gray-100">
        <div
          id="page"
          className="animated fadeIn my-auto shadow-2xl"
          style={{ animationDelay: '500ms' }}
        >
          {renderTemplate()}
        </div>
      </div>
    </div>
  );
};

export default App;
